export namespace ICreateRetailerBoardItemRequest {
  export namespace IImageData {
    /**
     * Return an instance of IImageData with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    export const build = (partial?: Partial<IImageData>): IImageData =>
      ({
        ...(partial ?? {}),
      }) as IImageData;
  }

  export interface IImageData {
    url: string | undefined;
    source_url: string | undefined;
  }

  /**
   * Return an instance of ICreateRetailerBoardItemRequest with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<ICreateRetailerBoardItemRequest>
  ): ICreateRetailerBoardItemRequest =>
    ({
      ...(partial ?? {}),
    }) as ICreateRetailerBoardItemRequest;
}

export interface ICreateRetailerBoardItemRequest {
  image_data: ICreateRetailerBoardItemRequest.IImageData | undefined;
  text: string | undefined;
  /**
   * If this is provided, instead of using imageData the best product image will be used
   */
  select_best_image: boolean | undefined;
  product_token: string | undefined;
  product_option_token: string | undefined;
  brand_token: string | undefined;
}
